module.exports = __webpack_public_path__ + "static/media/Programming_Essentials_in_Python.1ad92d77.png";